import { Component } from '@angular/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TableModule } from "primeng/table";
import { MessagingService } from '../../../../services/messaging.service';
import { MessagesState } from '../../../../state/messages/message-state';
import { Store } from '@ngxs/store';
import { ClientMessageHeader } from '../../../../models/client-message';
import { map, shareReplay, Observable, take } from 'rxjs';
import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import { Router } from '@angular/router';

const MAX_MESSAGES : number = 10;

@Component({
  selector: 'app-message-list',
  standalone: true,
  imports: [OverlayPanelModule, TableModule, AsyncPipe, DatePipe, CommonModule],
  templateUrl: './message-list.component.html',
  styleUrl: './message-list.component.scss',
})
export class MessageListComponent {

  messages$: Observable<ClientMessageHeader[]> = this._store.select(MessagesState.messages);

  allUnread$ = this.messages$.pipe(
    map(messages => messages.filter(m => !m.read)),
    shareReplay(1)
  );

  unreadMessages$ = this.allUnread$.pipe(
    map(messages => messages.slice(0, MAX_MESSAGES))
  );

  hasExtraMessages$ = this.allUnread$.pipe(
    map(messages => messages.length > MAX_MESSAGES)
  );

  messages: ClientMessageHeader[] = [];

  constructor(
    private _store: Store,
    private _messageService: MessagingService,
    private router: Router
  ) {
  }

  goToNotification(messageId: number) {
    this.router.navigate(['/notifications'], { queryParams: { messageId } });
  }

  refresh() {
  this.messages$.pipe(take(1)).subscribe(messages => {
    this.messages = [...(messages ?? [])]
      .filter(m => !m.read)
      .sort((a, b) =>
        new Date(b.messageTime).getTime() - new Date(a.messageTime).getTime()
      );

    console.log(this.messages);
  });
}
}